(function () {
  'use strict';

  function submitForm(form) {
    if (!form) return;
    form.submit();
  }

  function initSort() {
    document.querySelectorAll('[data-bb-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        submitForm(form);
      });
    });

    var mobileSort = document.querySelector('[data-bb-mobile-sort-select]');
    var mobileSortHidden = document.querySelector('[data-bb-mobile-sort-input]');
    if (mobileSort && mobileSortHidden) {
      mobileSort.addEventListener('change', function () {
        mobileSortHidden.value = mobileSort.value;
      });
    }
  }

  function initFacets() {
    document.querySelectorAll('[data-bb-facet-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        submitForm(input.closest('form'));
      });
    });

    document.querySelectorAll('[data-bb-price-min], [data-bb-price-max]').forEach(function (input) {
      input.addEventListener('change', function () {
        submitForm(input.closest('form'));
      });
    });
  }

  function initMobileFacets() {
    document.querySelectorAll('[data-bb-mobile-facets-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var details = btn.closest('details');
        if (details) details.removeAttribute('open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSort();
    initFacets();
    initMobileFacets();
  });
})();
